import { CMSExperiment } from '@/cmsComponents/DynamicComponent'

import { FeesCondition } from './fees'

// Planos disponíveis para maquininhas
export enum AllPlansForMachine {
  Super = 'super',
  Mega = 'mega',
  Pro = 'pro',
  Mei = 'mei',
  Turbo = 'turbo'
}

// Tipagem para os planos disponíveis para maquininhas
export type AllPlansForMachineType = `${AllPlansForMachine}`

// Planos disponíveis para smartphones
export enum AllPlansForSmartphone {
  Tapton = 'tapton'
}

// Tipagem para os planos disponíveis para smartphones
export type AllPlansForSmartphoneType = `${AllPlansForSmartphone}`

// Tipagem para todos os planos disponíveis
export type AllPlansType = AllPlansForMachineType | AllPlansForSmartphoneType

// Variações (tiers) de planos disponíveis para maquininhas
export enum AllTiersForMachine {
  TonMeiRegular = 'tonmei_tier_regular_mar25',
  TonMeiPlus = 'tonmei_tier_plus_mar25',
  TonMeiBase = 'tonmei_tier_base_mar25',
  MegatonRegular = 'tonmega_fev25',
  TonSuper = 'tonsuper_set24',
  TonProPromo = 'tonpro_total_tier_promo_jan25',
  TonProRegular = 'tonpro_total_tier_regular_jan25',
  TonProBase = 'tonpro_total_tier_base_jan25',
  TonTurboPromo = 'tonturbo_tier_promo_fev25',
  TonTurboRegular = 'tonturbo_tier_regular_fev25',
  TonTurboBase = 'tonturbo_tier_base_fev25',
  TonTurboPlus = 'tonturbo_tier_plus_fev25'
}

// Tipagem para as variações (tiers) de planos disponíveis para maquininhas
export type AllTiersForMachineType = `${AllTiersForMachine}`

// Variações (tiers) de planos disponíveis para smartphones
export enum AllTiersForSmartphone {
  Tapton = 'tap_nov24'
}

// Tipagem para as variações (tiers) de planos disponíveis para smartphones
export type AllTiersForSmartphoneType = `${AllTiersForSmartphone}`

// Tipagem para todos as variações (tiers) de planos disponíveis
export type AllTiersType = AllTiersForMachineType | AllTiersForSmartphoneType

// Tipagem para as informações comuns sobre os planos
export type AllPlansCommonInformation = {
  [key in AllPlansType]: {
    popularName: string
    shortPopularName: string
    description: string
  }
}

// Opções para liquidação dos recebíveis
export enum Liquidations {
  BusinessDay = 'business-day',
  Daily = 'daily'
}

// Tipagem para as opções de liquidação dos recebíveis
export type LiquidationsType = `${Liquidations}`

// TODO: Rever sobre esse enum, usado no componente NativeDropdown
export enum PromotionsTiersForNativeDropdown {
  TonProPromo = 0,
  TonProBase = 1,
  TonProRegular = 2,
  TonProPlus = 3
}

// Informações do Plano
export interface InformationsPlan {
  planName: AllPlansType
  details: InformationsDetailPlan
}

// Detalhes do Plano
export interface InformationsDetailPlan {
  allowed_liquidation_types: Liquidations[]
  commercial_name: string
  name: string
  conditions: FeesCondition[]
  description: string
  base_plan: string
  metadata?: {
    tier?: string
    minimum_tpv?: number
    maximum_tpv?: number
    maximum_duration?: number
    current_offer_position: number
    promo?: boolean
  }
  type: 'transactional' | 'tap_phone'
}

export interface CMSPlanDetail {
  order: number
  isDefault: boolean
  highlight: boolean
  hidden: boolean
  onlyForCompanies: boolean
  promotional: boolean
  commercialName: string
  shortCommercialName: string
  regulationLink?: string
  queryStringTaxValue?: string
  experiment?: CMSExperiment
  type: 'transactional' | 'tap_phone'
  catalog: {
    name: string
  }
  groupTier: string
  tiers: CMSPlanTier[]
  rexTierIDsExclude: string[]
  rexTierIDsInclude: string[]
  customData?: Partial<Record<string, unknown>>
}

export interface CMSPlanTier {
  tierName: string
  isDefaultTier: boolean
  isFakeTier: boolean
  customData?: Partial<Record<string, unknown>>
}
